import { ToggleButton, ToggleButtonGroup } from "@mui/material"
import type { FC, MouseEvent } from "react"

import { classNames } from "@/utils/utils"

export enum AccountingSubTab {
  AccountsPayable = "ACCOUNTS_PAYABLE",
  AccountsPayableBalanceAndTransactions = "AP_BALANCE_AND_TRANSACTIONS",
}

interface AccountingSubTabsProps {
  value: AccountingSubTab
  onChange: (value: AccountingSubTab) => void
  canViewAccountsPayableBalance?: boolean
}

const subTabButtonClassName = (isSelected: boolean): string =>
  classNames("rounded px-4 py-1.5 text-sm font-medium normal-case text-gray-700", {
    "bg-gray-300 text-gray-900": isSelected,
  })

export const AccountingSubTabs: FC<AccountingSubTabsProps> = ({
  value,
  onChange,
  canViewAccountsPayableBalance = false,
}) => {
  if (!canViewAccountsPayableBalance) return null

  const handleChange = (_event: MouseEvent<HTMLElement>, newValue: AccountingSubTab | null) => {
    if (newValue) onChange(newValue)
  }

  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={handleChange}
      className='w-fit rounded border border-gray-400'
      data-testid='accounts-payable.sub-tabs'
    >
      <ToggleButton
        value={AccountingSubTab.AccountsPayable}
        className={subTabButtonClassName(value === AccountingSubTab.AccountsPayable)}
        data-testid='accounts-payable.sub-tabs.accounts-payable-button'
      >
        Accounts Payable
      </ToggleButton>
      <ToggleButton
        value={AccountingSubTab.AccountsPayableBalanceAndTransactions}
        className={subTabButtonClassName(value === AccountingSubTab.AccountsPayableBalanceAndTransactions)}
        data-testid='accounts-payable.sub-tabs.balance-button'
      >
        AP Balance & Transactions
      </ToggleButton>
    </ToggleButtonGroup>
  )
}
